// here can put the basic configuration of axios 
import axios from 'axios'

const ClientAxios = axios.create({
  
  baseURL: "https://credito.cpapaseo.com/p1"
  // baseURL: "http://199.1.0.108:9001/"  
})

export default ClientAxios
